// extracted by mini-css-extract-plugin
export var width100 = "Y_w d_w";
export var design3Pos = "Y_yX d_0";